import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { TradePhaseEnum } from "../enum/TradePhaseEnum";
import { TradeStatusEnum } from "../enum/TradeStatusEnum";
import { ITrade } from "../interface/trade/ITrade";
import { IOpenTradeDto } from "../interface/trade/IOpenTradeDto";
import { UserTypeEnum } from "../enum/UserTypeEnum";
import { ITradeDashboard } from "../interface/trade/ITradeDashboard";
import { IBaseResponse } from "../interface/IBaseResponse";
import ITradeApprovalPhaseLog from "../interface/trade/ITradeApprovalPhaseLog";
import { IUpdatePendenciesRequest } from "../interface/trade/IUpdatePendenciesRequest";

enum TradeServiceEnum {
  getAll = "/",
  getById = "/",
  getTradesOpenFromMonitoring = "/get-trades-open-from-monitoring",
  getTradesOpenFromMonitoringDetails = "/get-trades-open-from-monitoring-details?",
  getTradeBCheckByStatusAndPhase = "/get-trades-bcheck-by-phase?",
  updatePendencies = "/update-pendencies",
  specialSituationApprovalLimit = "/get-trades-special-situation-approval-limit-by-current-user",
  createFromWorkflowWithPricing = "/create-trade-from-workflow-with-pricing",
  filterByDateRangeAndUserType = "/filter-by-date-range-and-user-type-dashboard",
  getTradeTrackHistory = "/get-trade-track-history?id="
}

const createParams = (status: TradeStatusEnum[], phases: TradePhaseEnum[]): string => {
  const paramList = [];
  let params = "";
  status.forEach(value => {
    paramList.push(`Status=${TradeStatusEnum[value]}`);
  });
  phases.forEach(value => {
    paramList.push(`Phase=${value}`);
  });
  paramList.forEach((value, index) => {
    params += index === 0 ? value : "&" + value;
  });
  return params;
};

export default class TradeService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade");
  }

  public async getAll() {
    const response: ITrade[] = await this.GET(TradeServiceEnum.getAll);
    return response;
  }

  public getById = async (id): Promise<ITrade> => await this.GET(TradeServiceEnum.getById + id);
  public getOpenFromMonitoring = async (): Promise<ITrade[]> => await this.GET(TradeServiceEnum.getTradesOpenFromMonitoring);
  public getOpenFromMonitoringDetails = async (phase, start, end): Promise<ITrade[]> =>
    await this.GET(TradeServiceEnum.getTradesOpenFromMonitoringDetails + `phase=${phase}&rangeStart=${start}&rangeEnd=${end}`);

  public getTradeBCheckByStatusAndPhase = async (status: TradeStatusEnum[], phases: TradePhaseEnum[]): Promise<ITrade[]> =>
    await this.GET(TradeServiceEnum.getTradeBCheckByStatusAndPhase + createParams(status, phases));

  public updatePendencies = async (data: IUpdatePendenciesRequest): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.updatePendencies, data);

  public getSpecialSituationApprovalLimitByCurrentUser = async () => await this.GET(TradeServiceEnum.specialSituationApprovalLimit);
  public postCreateFromWorkflowWithPricing = async (data: IOpenTradeDto): Promise<ITrade> => await this.POST(TradeServiceEnum.createFromWorkflowWithPricing, data);
  public filterByDateRangeAndUserType = async (dateRange: any[], userType: UserTypeEnum): Promise<ITradeDashboard[]> =>
    await this.POST(TradeServiceEnum.filterByDateRangeAndUserType, { startDate: dateRange[0], endDate: dateRange[1], userType });

  public getTradeTrackHistory = async (tradeId: number): Promise<ITradeApprovalPhaseLog[]> => await this.GET(TradeServiceEnum.getTradeTrackHistory + tradeId);
}
